import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatCheckboxChange, MatDialogRef, MatSelectChange } from '@angular/material';
import { CloseDialog } from '../../shared/dialog-close/dialog-close';
import { FormGroup, FormControl, Validators } from '../../../../node_modules/@angular/forms';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { Business } from '../../business/models/business.model';
import { NewBusiness } from '../../business/models/new-business-model';
import { BusinessTag } from '../../business/models/business-tag.model';
import { AuthService } from '../../auth/auth/auth.service';
import { Router } from '@angular/router';
import { AirportService } from '../airport.service';
import { UserService } from '../../shared/user/user.service';
import { CountriesService } from '../../shared/services/countries.service';
import { Address } from '../../shared/models/address.model';
import { formatPhoneString, undoPhoneFormat } from '../../util/phone';
var UserSubmitNewBusinessComponent = /** @class */ (function () {
    function UserSubmitNewBusinessComponent(_dialogRef, data, _businessManagerService, _auth, _router, _airportService, _userService, countriesService) {
        this._dialogRef = _dialogRef;
        this.data = data;
        this._businessManagerService = _businessManagerService;
        this._auth = _auth;
        this._router = _router;
        this._airportService = _airportService;
        this._userService = _userService;
        this.countriesService = countriesService;
        this.isLoading = true;
        this.businessPanelText = 'Expand Business Address Form';
        this.mailingPanelText = 'Expand Mailing Address Form';
        this.businessPanelIsActive = true;
        this.postalCodePlaceHolder = '';
        this.states = new Array();
        this.statesMailing = new Array();
        this.airport = data.airport;
        this.facilityType = data.facilityType;
        this.facilityTitleType = data.facilityType;
        if (data.facilityType === 'business') {
            this.facilityTitleType = 'Business';
        }
        this.business = new Business();
        this.business.address = new Address();
        this.business.address.country = 'US';
    }
    UserSubmitNewBusinessComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_1, _b, _c, e_2;
            var _this = this;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.endUser) {
                            this._auth.redirectToLogin();
                            return [2 /*return*/];
                        }
                        if (!this.business.mailingAddress) {
                            this.business.mailingAddress = new Address();
                        }
                        this.formGroup = new FormGroup({
                            terms: new FormControl(null, [Validators.required]),
                            name: new FormControl(this.business.name, [Validators.required, Validators.maxLength(50)]),
                            street1: new FormControl(this.business.address.street1, [Validators.required, Validators.maxLength(80)]),
                            street2: new FormControl(this.business.address.street2, [Validators.maxLength(80)]),
                            stateProvince: new FormControl(''),
                            postalCode: new FormControl(this.business.address.postalCode),
                            city: new FormControl(this.business.address.city, [Validators.required, Validators.maxLength(40)]),
                            country: new FormControl(this.business.address.country, [Validators.required]),
                            addressSame: new FormControl(true),
                            mailingStreet1: new FormControl(this.business.mailingAddress.street1, [Validators.maxLength(80)]),
                            mailingStreet2: new FormControl(this.business.mailingAddress.street2, [Validators.maxLength(80)]),
                            mailingStateProvince: new FormControl('', [Validators.maxLength(30)]),
                            mailingPostalCode: new FormControl(this.business.mailingAddress.postalCode, [Validators.maxLength(9)]),
                            mailingCity: new FormControl(this.business.mailingAddress.city, Validators.maxLength(40)),
                            mailingCountry: new FormControl(this.business.mailingAddress.country),
                            phone: new FormControl(formatPhoneString(this.business.phone), [Validators.pattern('^([(]\\d{3}[)]\\s\\d{3}[-]\\d{4})$')]),
                            fax: new FormControl(formatPhoneString(this.business.fax), [Validators.pattern('^([(]\\d{3}[)]\\s\\d{3}[-]\\d{4})$')]),
                            webAddress: new FormControl(this.business.webAddress, [Validators.maxLength(100)]),
                            email: new FormControl(this.business.email, [Validators.maxLength(55), this.customEmailValidator]),
                            locationOnField: new FormControl(this.business.locationOnField),
                            isLocatedOnField: new FormControl(true),
                            locationDesc: new FormControl(this.business.locationDesc, [Validators.maxLength(50)])
                        });
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.countriesService.getCountries()];
                    case 2:
                        _a.countries = _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _d.sent();
                        this._dialogRef.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4:
                        if (!this.business.address.country) return [3 /*break*/, 10];
                        _d.label = 5;
                    case 5:
                        _d.trys.push([5, 9, , 10]);
                        _b = this;
                        return [4 /*yield*/, this.countriesService.getStates(this.business.address.country)];
                    case 6:
                        _b.states = _d.sent();
                        this.states.length ? this.formGroup.controls['stateProvince'].setValidators([Validators.required, Validators.maxLength(50)]) :
                            this.formGroup.controls['stateProvince'].setValidators([Validators.maxLength(30)]);
                        if (!(this.business.mailingAddress && this.business.mailingAddress.country)) return [3 /*break*/, 8];
                        _c = this;
                        return [4 /*yield*/, this.countriesService.getStates(this.business.mailingAddress.country)];
                    case 7:
                        _c.statesMailing = _d.sent();
                        _d.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        e_2 = _d.sent();
                        this._dialogRef.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 10];
                    case 10:
                        this.isLoading = false;
                        this.formGroup.patchValue({ country: this.business.address.country || 'US' });
                        this.formGroup.patchValue({ mailingCountry: this.business.mailingAddress.country || 'US' });
                        this.formGroup.patchValue({ stateProvince: this.business.address.stateProvince || '' });
                        this.formGroup.patchValue({ mailingStateProvince: this.business.mailingAddress.stateProvince || '' });
                        if (this._compareAddress()) {
                            this.formGroup.patchValue({ addressSame: true });
                            this._changeMailingFieldsState(true);
                        }
                        if (!this.business.locationOnField) {
                            this.formGroup.patchValue({ isLocatedOnField: false, locationOnField: '' });
                        }
                        this._setPostalCodeValidation(this.business.address.country);
                        this._dialogRef.backdropClick().subscribe(function () {
                            var CLOSE_DIALOG = new CloseDialog();
                            CLOSE_DIALOG.cancelButtonClicked = true;
                            _this._dialogRef.close(CLOSE_DIALOG);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    UserSubmitNewBusinessComponent.prototype.customEmailValidator = function (control) {
        if (!control.value) {
            return null;
        }
        return Validators.email(control);
    };
    /**
     * triggered when value inside countries dropdown changes; event.value contains two digit country code.
     * @param {MatSelectChange} event
     * @return {Promise<void>}
     */
    UserSubmitNewBusinessComponent.prototype.countryChange = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // if value property is empty return
                        if (!event.value) {
                            return [2 /*return*/];
                        }
                        if (!(event.source.id.toString() === '1')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._setAddressForm(event.value)];
                    case 1:
                        _a.sent();
                        if (event.value === this.business.address.country) {
                            this.formGroup.patchValue({ stateProvince: this.business.address.stateProvince || '' });
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(event.source.id.toString() === '2')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._setMailingAddressForm(event.value)];
                    case 3:
                        _a.sent();
                        if (event.value === this.business.mailingAddress.country) {
                            this.formGroup.patchValue({ mailingStateProvince: this.business.mailingAddress.stateProvince || '' });
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     *  returns true if {Business} address and mailing address are the same.
     * @return {boolean}
     * @private
     */
    UserSubmitNewBusinessComponent.prototype._compareAddress = function () {
        return (this.business.address.street1 === this.business.mailingAddress.street1 &&
            this.business.address.street2 === this.business.mailingAddress.street2 &&
            this.business.address.city === this.business.mailingAddress.city &&
            this.business.address.stateProvince === this.business.mailingAddress.stateProvince &&
            this.business.address.country === this.business.mailingAddress.country);
    };
    /**
     * Function toggles mailing address fields in UI betweened disabled and enabled based on boolean flag passed in.
     * @param {boolean} disabled
     * @return {Promise<void>}
     * @private
     */
    UserSubmitNewBusinessComponent.prototype._changeMailingFieldsState = function (disabled) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_3;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!disabled) return [3 /*break*/, 1];
                        this.statesMailing = this.states;
                        this.formGroup.controls['mailingStreet1'].reset({ value: this.formGroup.controls['street1'].value, disabled: true });
                        this.formGroup.controls['mailingStreet2'].reset({ value: this.formGroup.controls['street2'].value, disabled: true });
                        this.formGroup.controls['mailingStateProvince'].reset({ value: this.formGroup.controls['stateProvince'].value, disabled: true });
                        this.formGroup.controls['mailingPostalCode'].reset({ value: this.formGroup.controls['postalCode'].value, disabled: true });
                        this.formGroup.controls['mailingCity'].reset({ value: this.formGroup.controls['city'].value, disabled: true });
                        this.formGroup.controls['mailingCountry'].reset({ value: this.formGroup.controls['country'].value, disabled: true });
                        return [3 /*break*/, 5];
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.countriesService.getStates(this.business.mailingAddress.country)];
                    case 2:
                        _a.statesMailing = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _b.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4:
                        this.formGroup.controls['mailingStreet1'].reset({ value: this.business.mailingAddress.street1, disabled: false });
                        this.formGroup.controls['mailingStreet2'].reset({ value: this.business.mailingAddress.street2, disabled: false });
                        this.formGroup.controls['mailingStateProvince'].reset({ value: this.business.mailingAddress.stateProvince, disabled: false });
                        this.formGroup.controls['mailingPostalCode'].reset({ value: this.business.mailingAddress.postalCode, disabled: false });
                        this.formGroup.controls['mailingCity'].reset({ value: this.business.mailingAddress.city, disabled: false });
                        this.formGroup.controls['mailingCountry'].reset({ value: this.business.mailingAddress.country, disabled: false });
                        this.formGroup.patchValue({
                            mailingStreet1: this.business.mailingAddress.street1,
                            mailingStreet2: this.business.mailingAddress.street2,
                            mailingStateProvince: this.business.mailingAddress.stateProvince,
                            mailingPostalCode: this.business.mailingAddress.postalCode,
                            mailingCity: this.business.mailingAddress.city,
                            mailingCountry: this.business.mailingAddress.country
                        });
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * called on is same as business address mat checkbox change event.
     * @param {MatCheckboxChange} event
     */
    UserSubmitNewBusinessComponent.prototype.addressSameChange = function (event) {
        this._changeMailingFieldsState(event.source.checked);
    };
    /**
     * changes states dropdown when a different country is chosen.
     * also changes validators depending on whether or states list exists for country
     * @param {string} value
     * @return {Promise<void>}
     * @private
     */
    UserSubmitNewBusinessComponent.prototype._setAddressForm = function (value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_4;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.countriesService.getStates(value)];
                    case 2:
                        _a.states = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _b.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4:
                        this.formGroup.patchValue({ stateProvince: '' });
                        this.isLoading = false;
                        if (!this.states.length) {
                            this.formGroup.controls['stateProvince'].setValidators([]);
                        }
                        else {
                            this.formGroup.controls['stateProvince'].setValidators([Validators.required]);
                        }
                        this._setPostalCodeValidation(value);
                        return [2 /*return*/];
                }
            });
        });
    };
    UserSubmitNewBusinessComponent.prototype._setMailingAddressForm = function (value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_5;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.countriesService.getStates(value)];
                    case 2:
                        _a.statesMailing = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_5 = _b.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 4];
                    case 4:
                        this.formGroup.patchValue({ mailingStateProvince: '' });
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * If countryCode is 'US', Postal Code field becomes required.
     * @param {string} countryCode
     * @private
     */
    UserSubmitNewBusinessComponent.prototype._setPostalCodeValidation = function (countryCode) {
        if (countryCode === 'US') {
            this.postalCodePlaceHolder = 'Zip Code *';
            this.formGroup.controls['postalCode'].setValidators([
                Validators.required,
                Validators.pattern('^\\d{5}$')
            ]);
            this.formGroup.controls['postalCode'].updateValueAndValidity();
        }
        else {
            this.postalCodePlaceHolder = 'Postal Code';
            this.formGroup.controls['postalCode'].setValidators([Validators.maxLength(9)]);
            this.formGroup.controls['postalCode'].updateValueAndValidity();
        }
    };
    UserSubmitNewBusinessComponent.prototype.businessPanelOpened = function () {
        this.businessPanelText = 'Enter Business Address';
        this.businessPanelIsActive = true;
    };
    UserSubmitNewBusinessComponent.prototype.businessPanelClosed = function () {
        this.businessPanelText = 'Expand Business Address Form';
    };
    UserSubmitNewBusinessComponent.prototype.mailingPanelOpened = function () {
        this.mailingPanelText = 'Enter Mailing Address';
        this.businessPanelIsActive = false;
        if (this.formGroup.controls['addressSame'].value) {
            this._changeMailingFieldsState(true);
        }
    };
    UserSubmitNewBusinessComponent.prototype.mailingPanelClosed = function () {
        this.mailingPanelText = 'Expand Mailing Address Form';
    };
    /**
     * formats passed in phone number string;
     * @param {string} field
     * @param {string} value
     * @return {string}
     */
    UserSubmitNewBusinessComponent.prototype.formatPhoneNumber = function (field, value) {
        var _a;
        var NEW_NUMBER = formatPhoneString(value);
        this.formGroup.patchValue((_a = {}, _a[field] = NEW_NUMBER, _a));
        return NEW_NUMBER;
    };
    /**
     * event triggered by keyup event on phone number or fax fields
     * @param event
     * @param {string} field
     * @param phoneInputObj
     */
    UserSubmitNewBusinessComponent.prototype.phoneFieldKeyUp = function (event, field, phoneInputObj) {
        var value = this.formGroup.get(field).value;
        var rawValue = undoPhoneFormat(value);
        var KEY = event.key;
        if (KEY === 'Backspace' && rawValue.length === 10 && phoneInputObj.selectionStart === rawValue.length) {
            this.formatPhoneNumber(field, value);
        }
        else if (phoneInputObj.selectionStart < value.length) {
        }
        else if (KEY === 'Backspace' || KEY === 'ArrowLeft' || KEY === 'ArrowRight') {
            return;
        }
        else {
            this.formatPhoneNumber(field, value);
        }
    };
    /**
     * triggered when phone number or fax field goes out of focus
     * @param {string} field
     */
    UserSubmitNewBusinessComponent.prototype.phoneFieldBlur = function (field) {
        var VALUE = this.formGroup.get(field).value;
        if (VALUE === '') {
            return;
        }
        this.formatPhoneNumber(field, VALUE);
    };
    UserSubmitNewBusinessComponent.prototype.isValid = function () {
        if (this.formGroup.valid && this.formGroup.controls['terms'].value) {
            return true;
        }
        return false;
    };
    UserSubmitNewBusinessComponent.prototype.reloadAirport = function (identifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(identifier, true)];
                    case 1:
                        _a.airport = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * closes modal
     */
    UserSubmitNewBusinessComponent.prototype.close = function (result) {
        if (result === void 0) { result = { cancelBtnClicked: true, success: false }; }
        if (result) {
            this._dialogRef.close(result);
        }
    };
    UserSubmitNewBusinessComponent.prototype.onSubmit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var CLOSE_DIALOG, newBusiness, BUSADDRESS, MAILADDRESS, BUSINESS, type, e_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.businessTags = [];
                        if (this.facilityType === 'Flying Club') {
                            this.facilityType = 'FLYING CLUB';
                            this.businessTags.push(Object.assign(new BusinessTag(), { tagName: 'Flying Club' }));
                        }
                        else if (this.facilityType === 'FBO') {
                            this.facilityType = 'BUSINESS';
                            this.businessTags.push(Object.assign(new BusinessTag(), { tagName: 'Admin::BusinessIsFbo' }));
                        }
                        else if (this.facilityType === 'Flight School') {
                            this.facilityType = 'BUSINESS';
                            this.businessTags.push(Object.assign(new BusinessTag(), { tagName: 'Flight Training::Certification::Private Pilot' }));
                        }
                        else {
                            this.facilityType = 'BUSINESS';
                        }
                        if (this.formGroup.controls['addressSame'].value) {
                            this._changeMailingFieldsState(true);
                        }
                        CLOSE_DIALOG = new CloseDialog();
                        BUSADDRESS = Object.assign(new Address(), {
                            street1: this.formGroup.value.street1,
                            street2: this.formGroup.value.street2 || null,
                            stateProvince: this.formGroup.value.stateProvince || null,
                            postalCode: this.formGroup.value.postalCode || null,
                            city: this.formGroup.value.city,
                            country: this.formGroup.value.country || null
                        });
                        MAILADDRESS = Object.assign(new Address(), {
                            street1: this.formGroup.getRawValue().mailingStreet1 || null,
                            street2: this.formGroup.getRawValue().mailingStreet2 || null,
                            stateProvince: this.formGroup.getRawValue().mailingStateProvince || null,
                            postalCode: this.formGroup.getRawValue().mailingPostalCode || null,
                            city: this.formGroup.getRawValue().mailingCity || null,
                            country: this.formGroup.getRawValue().mailingCountry || null
                        });
                        BUSINESS = Object.assign(new NewBusiness(), {
                            name: this.formGroup.controls['name'].value,
                            facilityType: this.facilityType,
                            airport: this.airport,
                            businessTags: this.businessTags,
                            userAdded: true,
                            phone: undoPhoneFormat(this.formGroup.value.phone),
                            fax: undoPhoneFormat(this.formGroup.value.fax),
                            webAddress: this.formGroup.value.webAddress,
                            email: this.formGroup.value.email,
                            address: BUSADDRESS,
                            mailingAddress: MAILADDRESS
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        this.isLoading = true;
                        return [4 /*yield*/, this._businessManagerService.createBusiness(BUSINESS)];
                    case 2:
                        newBusiness = _a.sent();
                        return [4 /*yield*/, this._userService.saveAcceptedTermsAndPrivacy()];
                    case 3:
                        _a.sent();
                        this.isLoading = false;
                        CLOSE_DIALOG.payload = newBusiness.id;
                        CLOSE_DIALOG.success = true;
                        type = 'business';
                        if (this.facilityType === 'FLYING CLUB') {
                            type = 'flyingclub';
                        }
                        this._router.navigateByUrl("/" + type + "/" + newBusiness.id);
                        return [3 /*break*/, 5];
                    case 4:
                        e_6 = _a.sent();
                        CLOSE_DIALOG.success = false;
                        if (e_6) {
                            CLOSE_DIALOG.error = e_6;
                        }
                        return [3 /*break*/, 5];
                    case 5:
                        this._dialogRef.close(CLOSE_DIALOG);
                        return [2 /*return*/];
                }
            });
        });
    };
    return UserSubmitNewBusinessComponent;
}());
export { UserSubmitNewBusinessComponent };
